import { Component, OnInit } from '@angular/core';
import {NgForm} from '@angular/forms';
import {AuthService} from '../../shared/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
isLoading = false;
  emailAddress = 'jane_doe@sample.email.edu';
  userPassword = 'userpassword';
  constructor(public authService: AuthService) { }

  ngOnInit() {
  }
  onLogin(f: NgForm) {
    if (f.invalid) {
      return;
    }
    this.isLoading = true;
    this.authService.login(f.value);
  }
}
